// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/note.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_studyo_today_planners_v1_resources_rich_text } from "./rich_text_pb.js";

/**
 * Describes the file studyo/today/planners/v1/resources/note.proto.
 */
export const file_studyo_today_planners_v1_resources_note = /*@__PURE__*/
  fileDesc("Ci1zdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL25vdGUucHJvdG8SInN0dWR5by50b2RheS5wbGFubmVycy52MS5yZXNvdXJjZXMi+gIKBE5vdGUSCgoCaWQYASABKAkSEgoKcGxhbm5lcl9pZBgCIAEoCRIXCg9jcmVhdG9yX3VzZXJfaWQYAyABKAkSOgoEdGV4dBgEIAEoCzIsLnN0dWR5by50b2RheS5wbGFubmVycy52MS5yZXNvdXJjZXMuUmljaFRleHQSMAoMY3JlYXRlZF90aW1lGAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIwCgx1cGRhdGVkX3RpbWUYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEigKBHRpbWUYByABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhIKCmlzX2FsbF9kYXkYCCABKAgSEwoLaXNfYXJjaGl2ZWQYCSABKAgSGQoRY291cnNlX3NlY3Rpb25faWQYCiABKAkSEgoKc3luY190b2tlbhgLIAEoAxIXCg9kdXBsaWNhdGlvbl9pZHMYDCADKAlCKqoCJ1N0dWR5by5Ub2RheS5QbGFubmVycy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z", [file_google_protobuf_timestamp, file_studyo_today_planners_v1_resources_rich_text]);

/**
 * Describes the message studyo.today.planners.v1.resources.Note.
 * Use `create(NoteSchema)` to create a new message.
 */
export const NoteSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_note, 0);

